export default {
  'component.contact.title.line1': 'Hva kan vi hjelpe deg med?',
  'component.contact.description':
    'Lurer du på hva boligen din er verdt, eller kanskje du er førstegangskjøper og vil vite mer om prosessen rundt kjøp av bolig? Vi hjelper deg gjerne. Send oss en melding via skjemaet nedenfor, eller kontakt oss via chat nede i høyre hjørne. Så vil vi hjelpe deg så snart som mulig!',
  'component.contact.bottom.label': 'Orgnr.',
};
